import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  MatCardModule,
  MatButtonModule,
  MatProgressSpinnerModule,
} from "@angular/material";
import { StructuredDiagnosisPanelComponent } from "./structured-diagnosis-panel.component";
import { MatCheckboxModule, MatIconModule } from '@angular/material';

@NgModule({
  declarations: [StructuredDiagnosisPanelComponent],
  imports: [
    CommonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule
  ],
  exports: [StructuredDiagnosisPanelComponent],
})
export class StructuredDiagnosisPanelModule {}
